import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import App from './App.vue'
import filters from './filters/index.js'
import router from './router/index.js'
import api from './api/api.js'
require("./assets/js/rem.min.js")
import { setgoindex } from './utils/utils'
import axios from 'axios';

// 引进ui插件vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// npm install animate.css --save安装，再引入（animate动画）
import animated from 'animate.css' 
Vue.use(animated)

// 引入字体图标
import "./styles/global.css"

Vue.prototype.$api = api;

//全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 引入轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

// 判断是否存在上一页
Vue.prototype.$setgoindex = setgoindex;
// 网络资源图片前缀
Vue.prototype.imageBase = 'http://material-1258501264.file.myqcloud.com/'
//获取当前是手机还是电脑
let width = document.body.clientWidth;
//设置设备类型
Vue.prototype.device = width > 1200 ? 'pc' : 'mobile';
window.addEventListener('resize',function(){
  //获取当前是手机还是电脑
  let width = document.body.clientWidth;
  //设置设备类型
  Vue.prototype.device = width > 1200 ? 'pc' : 'mobile';
},false)

// 引进微信js-sdk
import wechat from 'weixin-js-sdk';

/* 微信分享 */
Vue.prototype.wechatShare = (shareData,bool) => {  
    let resource = {
      title: '诚邀加盟哆咪，钱程似锦！',
      desc: '全行业全场景小程序电商解决方案，助力商家快速开启品牌电商大门瓜分网络流量红利。',
      link: '',
      img: 'http://agentweb.doomisoft.com/static/images/logo.png',
     }
  let obj = Object.assign({}, resource, shareData)
  let params = {url: window.location.href}
  console.log(api)
  api.getShareParam(params).then(data => {
   // 分享标题等参数
   const shareTitle = obj.title
   const shareDesc = obj.desc
   const shareLink = obj.link?obj.link:data.url
   const shareImgUrl = obj.img
   const config = {
    title: shareTitle, // 分享标题
    desc: shareDesc, // 分享描述
    link: shareLink, // 分享链接
    imgUrl: shareImgUrl, // 分享图标
    type: '', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    success: function () {
      // alert('分享成功')
    },
    cancel: function () {
      // alert('分享失败')
    }
   }

   wechat.config({
    debug: false,
    appId: 'wx1073a2ae2e60ce7e', // 和获取Ticke的必须一样------必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.noncestr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名，见附录1
    // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
    jsApiList: [
     'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo',
     'onMenuShareQZone', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice',
     'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice',
     'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice',
     'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu',
     'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem',
     'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard',
     'chooseCard', 'openCard'
    ]
   })
   // 处理验证失败的信息
   wechat.error(function (res) {
    console.log('验证失败返回的信息:', res)
   })
   // 处理验证成功的信息
   wechat.ready(function () {
     if(bool){
      wechat.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone', 'menuItem:openWithSafari', 'menuItem:openWithQQBrowser', 'menuItem:favorite']
      })
     }else{
      wechat.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone', 'menuItem:openWithSafari', 'menuItem:openWithQQBrowser', 'menuItem:favorite']
      })
     }
    // 分享给朋友
    wechat.onMenuShareAppMessage(config)
    // 分享到朋友圈
    wechat.onMenuShareTimeline(config)
    // 分享到qq
    wechat.onMenuShareQZone(config)
    // 分享到微博
    wechat.onMenuShareWeibo(config)
    // 分享到qq空间
    wechat.onMenuShareQZone(config)
    
   })
  })
  
 }
 
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js